import { Component,ViewChild,ViewEncapsulation  } from '@angular/core';
import { Chart, ChartConfiguration, ChartEvent, ChartType } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
declare var $:any;

@Component({
  selector: 'app-followers',
  templateUrl: './followers.component.html',
  styleUrls: ['./followers.component.scss']
})
export class FollowersComponent {
  
  public chartShow:boolean=false;
  public loading:boolean = false;
  public submitted:boolean = false;
  public detail :any=[];
  public types:any='stream';
  public filters:any='week'
  private newLabel? = 'New label';
  public previousLabel:any='';
  public nextLabel:any='';
  public ssd:boolean=false;

  public lineChartData: any = {  
    type: 'line',  
    labels: [  ],
    datasets: [{ data: [] } , { data: [] } , { data: [] }],
  };
 

  public lineChartOptions: ChartConfiguration['options'] = {
    scales: {
      y:
        {
          position: 'left',
        },
    },
    plugins: {
      legend: { display: true },    
    }
  };

  public lineChartType: ChartType = 'line';


  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  private static generateNumber(i: number): number {
    return Math.floor((Math.random() * (i < 2 ? 100 : 1000)) + 1);
  }

  public randomize(): void {
    for (let i = 0; i < this.lineChartData.datasets.length; i++) {
      for (let j = 0; j < this.lineChartData.datasets[i].data.length; j++) {
        this.lineChartData.datasets[i].data[j] = FollowersComponent.generateNumber(i);
      }
    }
    this.chart?.update();
  }

  // events
  public chartClicked({ event, active }: { event?: ChartEvent, active?: {}[] }): void {
    console.log(event, active);
  }

  public chartHovered({ event, active }: { event?: ChartEvent, active?: {}[] }): void {
    // console.log(event, active);
  }

  public hideOne(): void {
    const isHidden = this.chart?.isDatasetHidden(1);
    this.chart?.hideDataset(1, !isHidden);
  }

  public pushOne(): void {
    this.lineChartData.datasets.forEach((x:any, i:any) => {
      const num = FollowersComponent.generateNumber(i);
      x.data.push(num);
    });
    this.lineChartData?.labels?.push(`Label ${ this.lineChartData.labels.length }`);

    this.chart?.update();
  }

  public changeColor(): void {
    this.lineChartData.datasets[2].borderColor = 'green';
    this.lineChartData.datasets[2].backgroundColor = `rgba(0, 255, 0, 0.3)`;

    this.chart?.update();
  }

  public changeLabel(): void {
    const tmp = this.newLabel;
    this.newLabel = this.lineChartData.datasets[2].label;
    this.lineChartData.datasets[2].label = tmp;

    this.chart?.update();
  }

  
  constructor(public router: Router, private service: GlobalService) { 
    this.getDetail();
  }


  getDetail(){
    this.chartShow=false;
    this.loading=true;
    if(this.filters=='week'){
      $('#week').addClass(' active') ;  
      $('#year').removeClass(' active') ;  
      $('#month').removeClass(' active') ;    
    } else if (this.filters=='month'){
      $('#month').addClass(' active') ;  
      $('#week').removeClass(' active') ;  
      $('#year').removeClass(' active') ;    
    } else {
      $('#year').addClass(' active') ;  
      $('#week').removeClass(' active') ;  
      $('#month').removeClass(' active') ;    
    }
    this.chartShow=false;  
    this.lineChartData.labels= [ ];
    this.lineChartData.datasets= [ { data: [] } , { data: [] } , { data: [] }];
    const url = "/followers"; 
    var detail={
      "search":this.filters,
       "follower_type": this.types 
    };
    this.service.PostApis(detail,url).subscribe(((response:any)=>{
      if(response.success ==1) {
        var self=this;
        this.detail = response.data.section;
        if(response.data.followers.length !=0){
          response.data.followers.filter((el:any)=>{
            self.lineChartData.labels.push(el.id);
            self.lineChartData.datasets[0].data.push(el.value);
          })
        }
        if(response.data.streams.length !=0){
          response.data.streams.filter((el:any)=>{
            if(self.lineChartData.labels.length ==0){
              self.lineChartData.labels.push(el.id);
            }
            self.lineChartData.datasets[1].data.push(el.value);
          })
        }
        if(response.data.likes.length !=0){
          response.data.likes.filter((el:any)=>{
            if(self.lineChartData.labels.length ==0){
              self.lineChartData.labels.push(el.id);
            }
            self.lineChartData.datasets[2].data.push(el.value);
          })
        }
        self.lineChartData.datasets[0].label= 'Followers';
        self.lineChartData.datasets[1].label='Streams'; 
        self.lineChartData.datasets[2].label= 'Likes';
          this.chartShow=true; 
          this.ssd=true;
          this.loading=false
      } else {
        this.loading=false;
      }
    }), (error) => { this.loading =false; });
  }

}
